export default __webpack_public_path__ + "static/image-9-b2594e4621ad8bc1ab8409682c399ce4.jpg";